var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "row" },
    [
      _c(
        "el-col",
        { attrs: { span: 6 } },
        [_c("app-label", { attrs: { label: _vm.label, required: true } })],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("validation-provider", {
            attrs: { rules: "required", name: _vm.name + "_" + _vm.label },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("el-input", {
                      staticClass: "input",
                      class: { erro: errors.length },
                      model: {
                        value: _vm.computedContent,
                        callback: function($$v) {
                          _vm.computedContent = $$v
                        },
                        expression: "computedContent"
                      }
                    }),
                    _c("span", { staticClass: "help erro" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-128fa30c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-128fa30c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDisplayComInput.vue
// module id = null
// module chunks = 